<template>
  <v-container fluid class="pa-12" style="max-width: 1344px;">
    <v-row align="start" justify="center" class="px-12">
      <v-col cols="12">
        <v-card class="elevation-5">
          <v-card-title>Worker Report</v-card-title>
          
           <v-container fluid class="ma-2">
          <form>
              <v-select
                v-model="month"
                :items="months"
                :error-messages="monthErrors"
                label="Month"
                required
                @change="$v.month.$touch()"
                @blur="$v.month.$touch()"
              ></v-select>
               <v-select
                v-model="year"
                :items="years"
                :error-messages="yearErrors"
                label="Year"
                required
                @change="$v.year.$touch()"
                @blur="$v.year.$touch()"
              ></v-select>
              <v-btn class="mr-4" color="primary" :disabled="isLoading" @click="submit">submit</v-btn>
          </form>
           </v-container>
           </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required} from 'vuelidate/lib/validators'
//import ApiService from '@/services/api.service'
import axios from 'axios'

export default {
    name: 'hr_generate_report',
    mixins: [validationMixin],
    validations: {
        month: { required },
        year: { required },
  },
  computed : {
    years () {
      const years = new Date().getFullYear()
      return Array.from({length: years - 1980}, (value, index) => 2019 + index)
    },
    monthErrors() {
      const errors = []
      if (!this.$v.month.$dirty) return errors
      !this.$v.month.required && errors.push('Month is required')
      return errors
    },
    yearErrors() {
      const errors = []
      if (!this.$v.year.$dirty) return errors
      !this.$v.year.required && errors.push('Year is required')
      return errors
    }
  },
  data: () => ({
      year: null,
      month: null,
      isLoading: null,
      months: ['01', '02' , '03' , '04' , '05', '06' , '07' , '08', '09', '10','11' , '12'],
  }),
   methods: {
    submit(e) {
        e.preventDefault();
      this.$v.$touch()
      if (
        !this.$v.month.$error && !this.$v.year.$error
      ){
          this.isLoading = true
           let yearval = this.year;
           let monthval = this.month;
           let preparedate = yearval + "-" + monthval + "-" + "01";    
            
            axios({
                url: 'https://kokkiatapi.azurewebsites.net/api/WorkerAttendence/generate/' + preparedate,
                method: 'GET',
                responseType: 'blob',
            }).then((response) => {
                var fileURL = window.URL.createObjectURL(new Blob([response.data]));
                var fileLink = document.createElement('a');
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Report.xlsx');
                document.body.appendChild(fileLink);
                fileLink.click();
                this.isLoading = false;
            });
      }
   }
   }
}
</script>